import { render, staticRenderFns } from "./SportProComp.vue?vue&type=template&id=6991aecd&scoped=true"
import script from "./SportProComp.vue?vue&type=script&lang=js"
export * from "./SportProComp.vue?vue&type=script&lang=js"
import style0 from "./SportProComp.vue?vue&type=style&index=0&id=6991aecd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6991aecd",
  null
  
)

/* custom blocks */
import block0 from "./SportProComp.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports